const initShareButtons = () => {
    let sharerBlocks = document.querySelectorAll('.js-block-sharer');
    if (!sharerBlocks) return;

    let navigator = window.navigator;

    const setupSharerBlock = (block) => {
        // Find buttons within the block
        const copyLinkButton = block.querySelector('.js-copy-link');
        const nativeShareButton = block.querySelector('.js-native-share');

        const copyCurrentLink = () => {
            navigator.clipboard
                .writeText(window.location.href)
                .then(() => {
                    const popup = block.querySelector(
                        '.js-copy-confirmation'
                    );
                    popup.classList.add('show-popup');

                    // Hide the popup after a few seconds
                    setTimeout(() => {
                        popup.classList.remove('show-popup');
                    }, 1800); // Adjust time as needed
                })
                .catch((err) => {
                    console.error('Error copying link: ', err);
                    // Optionally, handle errors with a different popup or message
                });
        };

        // Function for native sharing
        const nativeShare = () => {
            if (navigator.share) {
                navigator
                    .share({ title: document.title, url: window.location.href })
                    .then()
                    .catch(console.error);
            }
        };

        // Event Listeners
        if (copyLinkButton)
            copyLinkButton.addEventListener('click', copyCurrentLink);
        if (nativeShareButton)
            nativeShareButton.addEventListener('click', nativeShare);

        // Show/Hide buttons based on native share availability
        if (navigator.share) {
            // If native sharing is available, hide the copy link button
           //   if (copyLinkButton) copyLinkButton.classList.add('hidden');
        } else {
            // If native sharing is not available, hide the native share button
            if (nativeShareButton) nativeShareButton.classList.add('hidden');
        }
    };

    sharerBlocks.forEach((block) => {
        setupSharerBlock(block);
    });
};

export { initShareButtons };
